import * as React from 'react';

var _circle, _path, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgRegionLock = function SvgRegionLock(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), _circle || (_circle = /*#__PURE__*/ React.createElement("circle", {
        cx: 44,
        cy: 44,
        r: 30,
        fill: "url(#paint0_linear_19_406)",
        fillOpacity: 0.16
    })), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_19_406)",
        fillRule: "evenodd",
        d: "M53.684 26.97q.685.652 1.624.652h14.109q1.002 0 1.655-.652.652-.652.652-1.656V14.558q0-1.003-.652-1.656-.653-.652-1.655-.652h-1.289V8.917q0-2.494-1.65-4.205Q64.828 3 62.353 3q-2.411 0-4.093 1.712-1.683 1.71-1.683 4.205v3.333h-1.27q-.937 0-1.623.652-.684.652-.684 1.656v10.756q0 1.003.684 1.656m12.124-14.72h-6.91V8.917q0-1.455 1-2.526.999-1.07 2.455-1.07t2.455 1.07q1 1.071 1 2.526zM28.295 67.631Q33.77 70.001 40 70t11.705-2.369 9.558-6.42q4.083-4.05 6.41-9.535Q70 46.192 70 39.897q0-1.403-.135-2.852a40 40 0 0 0-.359-2.814h-2.75q.392 1.487.536 2.814t.144 2.852q0 2.231-.305 4.292a23.3 23.3 0 0 1-.951 3.997H51.82q.379-2.436.536-4.414t.157-3.875q0-1.077-.051-2.362-.052-1.285-.174-3.304h-2.647q.205 1.75.256 3.067a67 67 0 0 1 .052 2.6q0 2.006-.148 3.92a53 53 0 0 1-.545 4.368H30.763a53 53 0 0 1-.545-4.369 51 51 0 0 1-.148-3.92q0-1.923.148-3.785.147-1.861.545-4.317h15.134V29.23H31.295q1.602-5.866 3.66-9.853T40 12.436a31.1 31.1 0 0 1 5.897 8.936V10.577a27 27 0 0 0-2.907-.433A32 32 0 0 0 40 10q-6.231 0-11.705 2.317t-9.558 6.369q-4.083 4.05-6.41 9.516Q10 33.667 10 39.897q0 6.295 2.327 11.78 2.327 5.483 6.41 9.535 4.083 4.05 9.558 6.42m-.135-19.445H13.82a23.3 23.3 0 0 1-.951-3.997 29 29 0 0 1-.305-4.292q0-2.167.305-4.198.304-2.032.951-3.904h14.36a44 44 0 0 0-.526 4.17 53 53 0 0 0-.148 3.932q0 1.879.138 3.927t.516 4.362m3.641 11.743q2.11 4.404 4.705 7.443-7.659-1.392-13.173-5.503-5.513-4.113-8.743-11.119h14.038a42.7 42.7 0 0 0 3.173 9.18m-3.154-30.698H14.59q3.173-7.052 8.737-11.25 5.565-4.2 13.096-5.334-2.616 3.398-4.609 7.613a47.6 47.6 0 0 0-3.167 8.97m16.709 30.695Q43.3 63.897 40 67.603q-3.237-3.532-5.292-7.5t-3.413-9.353h17.43q-1.315 5.205-3.37 9.176m11.096 1.965q-5.786 4.379-12.875 5.462 2.276-2.975 4.343-7.347t3.471-9.256h14.02q-3.173 6.763-8.96 11.141",
        clipRule: "evenodd"
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_19_406",
        x1: 14.627,
        x2: 73.165,
        y1: 44,
        y2: 44,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_19_406",
        x1: 10.645,
        x2: 70.865,
        y1: 36.499,
        y2: 36.499,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgRegionLock as ReactComponent };
//# sourceMappingURL=RegionLock.svg.es.js.map
